import { nationalities_en } from '@/components/shared/components/NewContextForms/AutocompleteNationalityFormField/constants/nationalities_en';
import { nationalities_es } from '@/components/shared/components/NewContextForms/AutocompleteNationalityFormField/constants/nationalities_es';
import { LANGUAGES } from '@/config/languages';
import { useConfigContext } from '@/contexts/ConfigContext/ConfigContext';

const TOP_NATIONALITIES_ALPHA2 = ['ES'];

export const useNationalities = () => {
  const {
    state: { language },
  } = useConfigContext();

  const getNationalityList = ()=>{
    switch (language) {
      case LANGUAGES.english:
        return nationalities_en;
      default:
        return nationalities_es;
    }
  };

  const getNationalitiesByLanguage = () => {
    const nationalityList = getNationalityList();

    return [
      ...TOP_NATIONALITIES_ALPHA2.map((nationalityAlpha2)=> nationalityList.find((nationality) => nationality.alpha2 === nationalityAlpha2)),
      ...nationalityList.filter((nationality) => !TOP_NATIONALITIES_ALPHA2.includes(nationality.alpha2)).sort((a, b) => a.display.localeCompare(b.display)),
    ];
  };

  const nationalities = getNationalitiesByLanguage();

  return { nationalities };
};
